function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStoreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#FFF",
    d: "M 90.5,-0.5 C 200.5,-0.5 310.5,-0.5 420.5,-0.5C 471.167,9.5 501.5,39.8333 511.5,90.5C 511.5,200.5 511.5,310.5 511.5,420.5C 501.5,471.167 471.167,501.5 420.5,511.5C 310.5,511.5 200.5,511.5 90.5,511.5C 39.8333,501.5 9.5,471.167 -0.5,420.5C -0.5,310.5 -0.5,200.5 -0.5,90.5C 9.5,39.8333 39.8333,9.5 90.5,-0.5 Z M 104.5,29.5 C 205.167,29.3333 305.834,29.5 406.5,30C 440.612,32.1238 464.112,48.9571 477,80.5C 479.413,88.3128 480.747,96.3128 481,104.5C 481.667,205.167 481.667,305.833 481,406.5C 478.876,440.612 462.043,464.112 430.5,477C 422.687,479.413 414.687,480.747 406.5,481C 305.833,481.667 205.167,481.667 104.5,481C 70.388,478.876 46.888,462.043 34,430.5C 31.5868,422.687 30.2534,414.687 30,406.5C 29.0243,302.149 29.3577,197.816 31,93.5C 36.5843,64.5826 53.0843,44.7492 80.5,34C 88.4974,31.7255 96.4974,30.2255 104.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#FFF",
    d: "M 223.5,104.5 C 234.098,102.56 242.931,105.56 250,113.5C 251.586,116.341 253.42,119.007 255.5,121.5C 265.103,104.033 278.769,99.8665 296.5,109C 307.973,120.219 309.473,132.719 301,146.5C 273.167,194.333 245.333,242.167 217.5,290C 235.842,290.167 254.176,290.667 272.5,291.5C 281.634,307.796 290.967,323.963 300.5,340C 233.456,340.986 166.456,340.653 99.5,339C 84.2371,329.453 80.7371,316.62 89,300.5C 92.8005,295.688 97.6338,292.521 103.5,291C 121.833,290.667 140.167,290.333 158.5,290C 180.793,251.915 202.96,213.749 225,175.5C 224.914,172.298 223.914,169.298 222,166.5C 216.161,157.492 210.828,148.159 206,138.5C 202.098,121.967 207.931,110.634 223.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#FFF",
    d: "M 294.5,193.5 C 296.624,194.031 298.124,195.365 299,197.5C 316.707,228.415 334.54,259.248 352.5,290C 370.833,290.333 389.167,290.667 407.5,291C 423.192,296.88 429.025,308.047 425,324.5C 421.641,332.529 415.808,337.696 407.5,340C 398.833,340.333 390.167,340.667 381.5,341C 387.46,351.085 393.293,361.252 399,371.5C 403.841,391.635 396.174,403.635 376,407.5C 368.235,406.951 361.568,403.951 356,398.5C 325.661,347.16 295.828,295.494 266.5,243.5C 276.29,227.055 285.623,210.388 294.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#FFF",
    d: "M 117.5,360.5 C 137.178,360.167 156.845,360.5 176.5,361.5C 169.252,374.332 161.752,386.998 154,399.5C 143.953,407.398 133.12,408.565 121.5,403C 111.9,395.877 108.4,386.377 111,374.5C 112.921,369.661 115.088,364.994 117.5,360.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreWhite);
export default __webpack_public_path__ + "static/media/app_store_white.18fff4b693bb933e85af608cd179d01e.svg";
export { ForwardRef as ReactComponent };